// import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import {connect} from 'react-redux';
import {setRunMode} from '../../reducers/mode';
import {FormattedMessage} from 'react-intl';
import {showAlertWithAixiong} from '../../reducers/alerts';

import styles from'./mode-switch.css';

class ModeSwitchComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleSwitch'
        ]);
        this.state = {
            burnMode: false,
        };
    }

    componentDidMount () {
        this.props.onClickSetRunMode(this.state.burnMode ? 0 : 1);
    }

    handleSwitch(){
        // 判断模式并dispatch 模式切换action
        const { onClickSetRunMode, burning, onShowAixiongInfo } = this.props
        const {burnMode} = this.state
        console.log('burning --> ', burning)
        if (burning) {
            onShowAixiongInfo({
                // maxDisplaySecs: 5,
                // message: 'hahaha',
                closeButton: true,
                content: <span>{'正在上传代码，请稍后再执行此操作'}</span>,
                iconSpinner: true
            });
            return 
        }
        
        this.setState({
            burnMode: !burnMode,
        }, () => {
            onClickSetRunMode(this.state.burnMode ? 0 : 1);
        });
    }
    render () {
        return (
            <div onClick={this.handleSwitch} className={styles.modeSwitchContainer}>
                <div className={styles.innerContainer}>
                    <div className={styles.toggle}>
                        <p>上传模式</p>
                    </div>
                    <div className={styles.toggle}>
                        <p>交互模式</p>
                    </div>
                </div>
                <div className={`${this.state.burnMode ? styles.innerContainerClipLeft : styles.innerContainerClipRight}`}>
                    <div className={styles.toggle}>
                        <p>上传模式</p>
                    </div>
                    <div className={styles.toggle}>
                        <p>交互模式</p>
                    </div>
                </div>
            </div>
        );
    }
};

ModeSwitchComponent.propTypes = {
    // setBurnResult: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    burning: state.scratchGui.code.burning,
    testModeSwitch: 'testModeSwitch'
});

const mapDispatchToProps = dispatch => ({
    onClickSetRunMode: runMode => dispatch(setRunMode(runMode)),
    onShowAixiongInfo: data => showAlertWithAixiong(dispatch, data)
});

export default connect(mapStateToProps, mapDispatchToProps)(ModeSwitchComponent);
